import React from "react";
import HorizontalRule from "../../../components/components/atoms/HorizontalRule";
import { Flex, Heading, Text } from "@telia/teddy";
import { RetailerFwaState } from "../../../../../models/state/retailer";

type PackageDetails = NonNullable<RetailerFwaState["selectedPackageDetails"]>;

const formatPrice = (price: string) => `${Math.round(Number(price))},-`;

interface Props {
    packageDetails: PackageDetails;
}

const FwaPackageSummary: React.FC<Props> = ({ packageDetails }) => {
    const showInstallationFee = !!packageDetails.installationPrice && Number(packageDetails.installationPrice) > 0;

    const installationLabel = showInstallationFee
        ? formatPrice(packageDetails.installationPrice!)
        : packageDetails.installationType?.toLowerCase().includes("selfinstall")
          ? "Montere selv"
          : (packageDetails.installationType ?? "Montere selv");

    return (
        <>
            <div className="retailer-summary-fwa-package">
                <Heading as="h2" variant="title-100" mt="400" mb="200">
                    Trådløst Bredbånd
                </Heading>
                <Flex direction="column" gap="100">
                    <Text variant="paragraph-100-bold">{packageDetails.name}</Text>
                    {packageDetails.monthlyPrice && (
                        <Text>
                            Månedspris:{" "}
                            {packageDetails.monthlyRegularPrice && (
                                <Text as="span" style={{ textDecoration: "line-through", marginRight: "0.25rem" }}>
                                    {formatPrice(packageDetails.monthlyRegularPrice)} /md.
                                </Text>
                            )}
                            <Text as="span" variant="paragraph-100-bold">
                                {formatPrice(packageDetails.monthlyPrice)} /md.
                            </Text>
                        </Text>
                    )}
                    <Text>
                        Installasjon:{" "}
                        <Text as="span" variant="paragraph-100-bold">
                            {installationLabel}
                        </Text>
                    </Text>
                </Flex>
            </div>
            <HorizontalRule />
        </>
    );
};

export default FwaPackageSummary;
